const findModule = module => {
  switch (module) {
    case 'components/shared_whiteboards/replaceLinksByContainers':
      return require('components/shared_whiteboards/replaceLinksByContainers');
    case 'components/shared_whiteboards':
      return require('components/shared_whiteboards');
    case 'javascripts/getting_started':
      return require('javascripts/getting_started');
    case 'javascripts/popup_priority':
      return require('javascripts/popup_priority');
    case 'javascripts/published_bookmark_refresh':
      return require('javascripts/published_bookmark_refresh');
    // Other misc functions
    // If module is not declared, show a console error.
    default:
      console.error(
        `Module '${module}' must be declared in \`app/assets/javascripts/idea_portals/window_require.js\` to be \`require\`d in javascript_tag snippets.`
      );
  }
};

export default module => {
  const requiredModule = findModule(module);
  if (requiredModule.default) {
    return requiredModule.default;
  } else {
    return requiredModule;
  }
};
